// import { createSelector } from 'reselect';

export const getAccount = state => state.getIn(['login', 'account']);
export const getPassword = state => state.getIn(['login', 'password']);
export const getErrMessage = state => state.getIn(['login', 'errMessage']);
export const getShowLoading = state => state.getIn(['login', 'showLoading']);
export const getMemberId = state => state.getIn(['login', 'memberId']);